import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import i18n from './i18n';

Vue.config.productionTip = false;
Vue.prototype.window = window;
Vue.use(VueI18n);

new Vue({
  i18n,
  render: (h) => h(App),
  devServer: {
    disableHostCheck: true,
  },
}).$mount('#hpp');
